import { store } from '../../store'

export const editQuiz = async ( id: number, quiz: any ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/quizes/${ id }`, {
            body: JSON.stringify( quiz ),
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'EDIT_QUIZ_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'EDIT_QUIZ_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'EDIT_QUIZ_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'EDIT_QUIZ_OK' } )

}